<template>
  <div>
    <input type="hidden" class="schedule_ids" :value="item.id">
    <div :data-jobRoleId="item.jobRole.id" :data-rosterSchedule="item.roster_schedule_id">
      <input type="hidden" :class="'start_time'+[day]+[index]+[keyInt]" :value="item.start_time">
      <input type="hidden" :class="'roster_schedule_id'+[day]+[index]+[keyInt]"
             :value="item.roster_schedule_id">
      <input type="hidden" :class="'end_time'+[day]+[index]+[keyInt]" :value="item.end_time">
      <input type="hidden" :class="'is_floating_shift'+[day]+[index]+[keyInt]" :value="item.is_floating_shift">
      <input type="hidden" :class="'is_shift_available'+[day]+[index]+[keyInt]" :value="item.is_shift_available">
      <input type="hidden" :class="'employee_id'+[day]+[index]+[keyInt]" :value="item.employee?item.employee.id:''">
      <input type="hidden" :class="'job_role_id'+[day]+[index]+[keyInt]" :value="item.jobRole.id">
      <input type="hidden" :class="'break_time'+[day]+[index]+[keyInt]" :value="item.break_time">
      <input type="hidden" :class="'comment'+[day]+[index]+[keyInt]" :value="item.comment">
    </div>
    <div class="overlayer-btn">
      <ul>
        <li>
          <a href="#" class="over-btn" @click.stop.prevent="singleCopyTestingCode(week,day,index,keyInt)"
             v-show="isCopy==false"><i class="ico-Copy"></i></a>
        </li>
        <li>
          <a class="over-btn" data-toggle="collapse" :data-info-record="info.id" :data-item-record="item.id" @click=editSchedule(item.id)
             :href="'#shift-dropdown-edit'+index+'-'+week+day+keyInt" role="button"
             aria-expanded="false" aria-controls="shift-dropdown">
            <clip-loader :loading="loadingSpin" :size="size" :color="spinnerColor"></clip-loader>
            <i class="ico-pencil" v-show="isShowPencil"></i></a>
        </li>
      </ul>
    </div>
    <div class="shift-dropmenu collapse" v-show="isEditModalVisible"
         :id="'shift-dropdown-edit'+index+'-'+week+day+keyInt">
      <div class="drop-header">
        <div class="drop-title ">
          <h5>Set Times <span v-if="shiftTme" class="text-danger">({{shiftTme}} Hours)</span></h5>
          Flexible Time  <input type="checkbox" v-model="scheduleForm.is_floating_shift" :true-value="1" :false-value="0">
        </div>
        <a data-toggle="collapse" @click="closeModalBtnEdit" class="close"
           role="button" aria-expanded="false"
           aria-controls="shift-dropdown">
          <span class="ico-cross"></span>
        </a>

      </div>
      <div class="drop-body">

        <div class="inputs-wrapper">
          <div class="inputs-holder">
            <div class="field-col">
              <label>Start Time</label>
              <input type="time" v-model="scheduleForm.start_time" @change="calculateShiftTime(day)" class="form-control"
                     value="14:00">
            </div>
            <div class="field-col">
              <label>End Time</label>
              <input type="time" v-model="scheduleForm.end_time" @change="calculateShiftTime(day)" class="form-control"
                     value="22:00">
              <span class="next-text text-danger" v-if="shiftEndTmeAlert" >Ending next day</span>
            </div>
            <div class="field-col">
              <label >Break Time</label>
              <div class="nav-selectdrop">
                <select class="form-control  " v-model="scheduleForm.break_time">
                  <option value="">Select</option>
                  <option :value="20">20 Min</option>
                  <option :value="30">30 Min</option>
                  <option :value="40">40 Min</option>
                  <option :value="60">60 Min</option>
                </select>
              </div>
            </div>
          </div>

          <div class="inputs-holder" v-bind:class="{ 'job-roll': newJobRoleNameForm }">
            <div class="field-col">
              <label>Job Role(s)</label>
              <div class="nav-selectdrop">
                <select  v-model="scheduleForm.job_role_id"
                         @change="getEmployeeByJobRoleChange($event)" class="form-control  ">
                  <option>Select</option>
                  <option v-if="jobTypes.length>0" v-for="value in jobTypes" :value="value.id">
                    <i class="ico ico-fill-circle"  :style="'color:'+value.color"></i>  {{ value.name }}
                  </option>
                  <option disabled="">-&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;</option>
                  <option disabled="">Missing a job role?</option>
                  <option class="mt-20 border-top" value="new">+Create new job role</option>
                </select>
                <div class="overlayer-input">

                  <input type="text" class="form-control  " v-model="new_job_role_name">

                  <button class="btn btn-outline-primary btn-save"
                          v-on:click="saveNewCompanyJobRole">Save
                  </button>
                  <button class="btn btn-outline-primary btn-cancel"
                          v-on:click="cancelNewCompanyJobRole">Cancel
                  </button>
                </div>
              </div>
            </div>
            <div class="field-col">
              <label>Employee</label>
              <div class="nav-selectdrop">
                <select id="inputState" class="form-control text-capitalize"
                        v-model="scheduleForm.employee_id">
                  <option value="">Open Shift</option>
                  <option :value="jobTypesEmployees.adminDetail.employee.id" v-if="jobTypesEmployees.adminDetail">{{jobTypesEmployees.adminDetail.employee.name}}</option>
                  <option class="text-capitalize" v-if="jobTypesEmployees.employees.length>0 && value.employee.empRequest.length==''"
                          v-for="value in jobTypesEmployees.employees"
                          :value="value.employee.id">{{ value.employee.name }}
                  </option>
                  <option disabled=""  >-------------------</option>
                  <option disabled="" >Employees In Leave</option>
                  <option class="text-capitalize" v-if="jobTypesEmployees.employees.length>0 && value.employee.empRequest.length>0"
                          v-for="value in jobTypesEmployees.employees"
                          :value="value.employee.id">{{ value.employee.name }}
                  </option>
                  <option disabled=""></option>
                </select>
              </div>
            </div>
            <div class="field-col">
              <label>Note (optional)</label>
              <input type="text" v-model="scheduleForm.comment" class="form-control"
                     value="Add a Note ...">
            </div>
          </div>
        </div>
      </div>
      <div class="drop-footer">
        <button class="btn btn-outline-primary btn-sm" @click="deleteSchedule(item.id)">Delete
        </button>
        <button class="btn btn-outline-primary btn-sm" @click="update(item.id)">Save
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import moment from 'moment'
import router from '../../../router/router'
import axios from "axios";
import ClipLoader from 'vue-spinner/src/ClipLoader.vue';
import Swal from "sweetalert2";

export default {
  name: 'jobRole',
  components: {ClipLoader},
  // props:["jobTypes","week","day","index","keyInt","info","item"],
  props:["item","week","day","index","keyInt","jobTypes","info"],
  data() {
    return{
      size        : '15px',
      spinnerColor: '#00779C',
      loadingSpin : false,
      isShowPencil : true,
      shiftTme : '',
      shiftEndTmeAlert:false,
      isCopy: false,
      isPaste: false,
      isEditModalVisible: false,
      jobTypesEmployees:[],
      newJobRoleNameForm: false,
      new_job_role_name: '',
      new_job_role_name_error: '',
      company_id: this.$store.getters.getSelectedCompany.id,
      roster_schedule_id: this.$route.params.id,
      scheduleForm: {
        date: '',
        start_time: '',
        end_time: '',
        break_time: '',
        job_role_id: '',
        employee_id: '',
        is_floating_shift: '',
        company_id: this.$store.getters.getSelectedCompany.id,
        comment: '',
      },
    }
  },
  created() {
    this.calculateShiftTime(this.day);
  },
  methods:{
    calculateShiftTime(date){
      this.shiftTme= this.calculateHourMinutes2( this.scheduleForm.start_time, this.scheduleForm.end_time,date);
      if(this.scheduleForm.start_time<this.scheduleForm.end_time){
        this.shiftEndTmeAlert=false;
      }else{
        this.shiftEndTmeAlert=true;
      }
    },

    editSchedule(id) {
      this.loadingSpin = true;
      this.isShowPencil = false;
      axios.get(this.$Schedule + '/' + id + '/edit', {
        headers: this.getAuthHeader(),
      })
        .then(res => {
          this.loadingSpin = false;
          this.isEditModalVisible = true;
          this.isShowPencil = true;
          if (res.data.status == 200) {
            this.scheduleForm = res.data.result;
            this.calculateShiftTime(this.day);
            this.getEmployeeByJobRoleId(this.scheduleForm.job_role_id);
          }
        });
    },
    getEmployeeByJobRoleId(id) {
      axios.get(this.$GetEmployeesByJobRolesType, {
        headers: this.getAuthHeader(),
        params: {
          job_role_id: id,
          company_id: this.company_id,
          date: this.day,
        }
      })
        .then(res => {
          if (res.data.status == 200) {
            this.jobTypesEmployees = res.data.result;
          }
        });
    },
    closeModalBtnEdit() {
      this.isEditModalVisible = false;
    },
    getEmployeeByJobRoleChange(event) {
      if (event.target.value === 'new') {
        this.newJobRoleNameForm = true;
        return 1;
      } else {
        if(event.target.value !==''){
          this.jobTypesEmployees = [];
          axios.get(this.$GetEmployeesByJobRolesType, {
            headers: this.getAuthHeader(),
            params: {
              job_role_id: event.target.value,
              company_id: this.company_id,
              date: this.day,
            }
          })
            .then(res => {
              if (res.data.status == 200) {
                this.jobTypesEmployees= res.data.result;
              }
            });
        }
      }
    },
    deleteSchedule(id) {
      new Swal({
        title: "Delete?",
        icon: "warning",
        text: "Do you really want to delete?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes, Delete it!"
      }).then((result) => {
        if (result.value) {
          axios.delete(this.$Schedules + '/' + id,
            {headers: this.getAuthHeader()})
            .then((res) => {
              if (res.status == 200) {
                this.isEditModalVisible = false;
                this.$emit('isDeleted',true)
              }
            });
        }})
    },
    update(id) {
      axios.put(this.$Schedules + '/' + id,
        {
          date: this.scheduleForm.date,
          start_time: this.scheduleForm.start_time,
          end_time: this.scheduleForm.end_time,
          break_time: this.scheduleForm.break_time,
          job_role_id: this.scheduleForm.job_role_id,
          employee_id: this.scheduleForm.employee_id,
          company_id: this.company_id,
          comment: this.scheduleForm.comment,
          is_floating_shift: this.scheduleForm.is_floating_shift,
          is_shift_available: this.scheduleForm.is_shift_available,
        }, {headers: this.getAuthHeader()})
        .then((res) => {
          if (res.status == 200) {
            this.isEditModalVisible = false;
            this.isPublished = true;
            this.$emit('updateShift',res)
            // $root.$toast.success(res.data.message);
          }
        });
    },
    saveNewCompanyJobRole() {
      if (this.new_job_role_name == '') {
        this.new_job_role_name_error = 'Job role is required';
      } else {
        this.new_job_role_name_error = '';
        axios.post(this.$JobRolesType,
          {
            company_id: this.company_id,
            name: this.new_job_role_name,
          }, {headers: this.getAuthHeader()})
          .then((res) => {
            if (res.status == 200) {
              this.new_job_role_name = '';
              this.scheduleForm.job_role_id = '';
              this.jobTypes.push({id:res.data.result.id,name:res.data.result.name});
              this.newJobRoleNameForm = false;
              $root.$toast.success(res.data.message);
            }
          });
      }
    },
    cancelNewCompanyJobRole() {
      this.new_job_role_name_error = '';
      this.scheduleForm.job_role_id = '';
      this.newJobRoleNameForm = false;
    },
    // copy code function
    singleCopyTestingCode(week, date, key,keyInt) {
     // console.log('week='+week,'date='+ date,'key='+ key,'keyInt='+keyInt,document.querySelectorAll('.is_floating_shift' + date + key+keyInt)[0].value);
      this.scheduleForm.company_id = this.company_id;
      this.scheduleForm.roster_schedule_id = document.querySelectorAll('.roster_schedule_id' + date + key+keyInt)[0].value;
      this.scheduleForm.start_time = document.querySelectorAll('.start_time' + date + key+keyInt)[0].value;
      this.scheduleForm.end_time = document.querySelectorAll('.end_time' + date + key+keyInt)[0].value;
      this.scheduleForm.is_floating_shift = document.querySelectorAll('.is_floating_shift' + date + key+keyInt)[0].value;
      this.scheduleForm.is_shift_available = document.querySelectorAll('.is_shift_available' + date + key+keyInt)[0].value;
      this.scheduleForm.employee_id = document.querySelectorAll('.employee_id' + date + key+keyInt)[0].value;
      this.scheduleForm.job_role_id = document.querySelectorAll('.job_role_id' + date + key+keyInt)[0].value;
      this.scheduleForm.break_time = document.querySelectorAll('.break_time' + [date + key+keyInt])[0].value;
      this.scheduleForm.comment = document.querySelectorAll('.comment' + [date + key+keyInt])[0].value;
      this.$emit('isCopy',this.scheduleForm)
    },
  }
}
</script>
<style scoped>

.shift-dropmenu .inputs-holder{
  align-items: flex-start;
}
.next-text{
  display: block;
  margin-top: 6px;
}
</style>
